"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGIMENES_FISCALES = void 0;
var REGIMENES_FISCALES = exports.REGIMENES_FISCALES = ['601', '603', '605', '606', '607', '608', '610', '611', '612', '614', '615', '616', '620', '621', '622', '623', '624', '625', '626'];